import { render, staticRenderFns } from "./SeasonSolo.vue?vue&type=template&id=585258f9"
import script from "./SeasonSolo.vue?vue&type=script&lang=js"
export * from "./SeasonSolo.vue?vue&type=script&lang=js"
import style0 from "./SeasonSolo.vue?vue&type=style&index=0&id=585258f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports